import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import questionnaireScopeApi from "../../api/questionnaireScopeApi";
import ageRanges from "../../data/ageRanges";
import biologicalSexList from "../../data/biologicalSex";
import jobArea from "../../data/jobArea";
import CgsSummaryChart from "../../components/analytics/CgsSummaryChart";
import styles from "./CgsAnalyticsPage.module.css";

const chartConfigs = [
  {
    key: "bai",
    metricKey: "bai",
    title: "Cuestionario de Ansiedad de Beck",
    colors: ["var(--color-delilife)", "var(--color-amarillo)", "var(--color-rojo)"],
    data: {
      totalRespondents: 18,
      response: [
        { result0: { total: 7, label: "muy baja" } },
        { result1: { total: 8, label: "moderada" } },
        { result2: { total: 3, label: "severa" } }
      ]
    }
  },
  {
    key: "bdi",
    metricKey: "bdi",
    title: "Inventario de Depresión de Beck (BDI)",
    colors: ["var(--color-delilife)", "var(--color-amarillo)", "#FFA500", "var(--color-rojo)"],
    data: {
      totalRespondents: 18,
      response: [
        { result0: { total: 6, label: "Depresion minima" } },
        { result1: { total: 5, label: "Depresion leve" } },
        { result2: { total: 4, label: "Depresion moderada" } },
        { result3: { total: 3, label: "Depresion grave" } }
      ]
    }
  },
  {
    key: "psqi",
    metricKey: "psqi",
    title: "Índice de Calidad de Sueño de Pittsburgh",
    colors: ["var(--color-delilife)", "var(--color-rojo)"],
    data: {
      totalRespondents: 18,
      response: [
        { result0: { total: 11, label: "Buena calidad de sueño" } },
        { result1: { total: 7, label: "Alteracion de la calidad del sueño" } }
      ]
    }
  },
  {
    key: "pss",
    metricKey: "pss",
    title: "Escala de Estrés Percibido",
    colors: ["var(--color-delilife)", "var(--color-amarillo)", "var(--color-rojo)"],
    data: {
      totalRespondents: 18,
      response: [
        { result0: { total: 9, label: "Estres percibido bajo a moderado-bajo" } },
        { result1: { total: 4, label: "Estres moderado" } },
        { result2: { total: 5, label: "Estres elevado" } }
      ]
    }
  }
];

export default function CgsAnalyticsPage({ companyId: companyIdProp }) {
  const { companyId: companyIdParam, branchId } = useParams();
  const companyId = companyIdProp || companyIdParam;
  const analyticsScopeId = branchId || companyId;
  const areaScopeId = analyticsScopeId;
  const [companyName, setCompanyName] = useState("");
  const [companyJobAreas, setCompanyJobAreas] = useState([]);

  useEffect(() => {
    if (!areaScopeId) return;

    (async () => {
      try {
        const scope = await questionnaireScopeApi.getById(areaScopeId);
        setCompanyName(scope?.name || "");
        setCompanyJobAreas(scope?.jobAreas || []);
      } catch (err) {
        console.error("Error cargando empresa/sucursal para filtros CGS:", err);
        setCompanyJobAreas([]);
      }
    })();
  }, [areaScopeId]);

  const jobAreaOptions = companyJobAreas.length ? companyJobAreas : jobArea;
  const filterConfigs = useMemo(
    () => [
      { name: "ageRange", label: "Rango de edad", options: ageRanges },
      { name: "jobArea", label: "Área de trabajo", options: jobAreaOptions },
      { name: "biologicalSex", label: "Sexo biológico", options: biologicalSexList }
    ],
    [jobAreaOptions]
  );

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <div>
          <span className={styles.eyebrow}>ANALÍTICA DE BIENESTAR</span>
          <h2 className={styles.title}>Bienestar emocional</h2>
          <p className={styles.subheader}>
            Resultados de <span className={styles.companyName}>{companyName || areaScopeId}</span>
          </p>
        </div>
        <div className={styles.summaryCard}>
          <span>Instrumentos evaluados</span>
          <strong>{chartConfigs.length}</strong>
        </div>
      </header>

      <section className={styles.chartsGrid}>
        {chartConfigs.map((chart) => (
          <div className={styles.chartCard} key={chart.key}>
            <CgsSummaryChart
              title={chart.title}
              companyId={analyticsScopeId}
              metricKey={chart.metricKey}
              filterConfigs={filterConfigs}
              initialData={chart.data}
              colors={chart.colors}
            />
          </div>
        ))}
      </section>
    </div>
  );
}
